import { configureStore } from "@reduxjs/toolkit";
import {
	login,
	loginCheck,
	ProfilegetApi,
	FooterdetailsApi,
	Faqsgetapi,
	ServiceApi,
	Jobgetapi,
	Clientgetapi,
	Professionalgetapi,
	JobtrackgetApi,
	ProjectTrackgetapi,
	Reviewapi,
	Notigetapi,
	cardapi,
} from "./action"
const store = configureStore({
	reducer: {
		login,
		loginCheck,
		ProfilegetApi,
		FooterdetailsApi,
		Faqsgetapi,
		ServiceApi,
		Jobgetapi,
		Clientgetapi,
		Professionalgetapi,
		JobtrackgetApi,
		ProjectTrackgetapi,
		Reviewapi,
		Notigetapi,
		cardapi,
	},
})
export default store